import React from 'react';
import {
    Pagination,
    Box,
    Typography,
    SxProps,
    Select,
    MenuItem,
    SelectChangeEvent
} from '@mui/material';
import { Theme } from '@mui/material/styles';

interface CustomPaginationProps {
    count: number;
    rowsPerPage: number;
    page: number;
    onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
    onRowsPerPageChange: (event: SelectChangeEvent) => void;
    paginationStyle?: SxProps<Theme>;
    rowsPerPageOptions?: number[];
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
    count,
    rowsPerPage,
    page,
    onPageChange,
    onRowsPerPageChange,
    paginationStyle = {},
    rowsPerPageOptions = [15, 20, 30, 50, 100],
}) => {
    const totalPages = Math.ceil(count / rowsPerPage);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 1,
                ...paginationStyle,
            }}
        >
            <Typography variant="body2" sx={{ mr: 1 }}>
                {/* You can display record range here if needed */}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Select
                    sx={{ mr: 1 }}
                    value={rowsPerPage.toString()}
                    onChange={onRowsPerPageChange}
                    size="small"
                >
                    {rowsPerPageOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={onPageChange}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    size="medium"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                        '& .MuiPaginationItem-root': {
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease',
                        },
                        '& .MuiPaginationItem-root:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .Mui-selected': {
                            backgroundColor: '#1976d2',
                            color: '#fff',
                            fontWeight: 'bold',
                            border: 'none',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default CustomPagination;
